(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  function addBdynamicAttribution() {
    document
      .querySelectorAll('[data-testid="footer-utilities"]')
      .forEach(function (utilities) {
        const copyrightBlock = utilities.firstElementChild;

        if (
          !copyrightBlock ||
          copyrightBlock.querySelector('.bdynamic-powered-by')
        ) {
          return;
        }

        const separator = document.createTextNode(' · ');
        const attributionLink = document.createElement('a');

        attributionLink.className = 'bdynamic-powered-by';
        attributionLink.href = 'https://bdynamicmarketing.com';
        attributionLink.target = '_blank';
        attributionLink.rel = 'noopener noreferrer';
        attributionLink.textContent = 'Powered by @BdynamicMarketing';

        copyrightBlock.appendChild(separator);
        copyrightBlock.appendChild(attributionLink);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBdynamicAttribution);
  } else {
    addBdynamicAttribution();
  }

  document.addEventListener('shopify:section:load', addBdynamicAttribution);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
